import { render, staticRenderFns } from "./plan-bodega.vue?vue&type=template&id=80547cfe&scoped=true&"
import script from "./plan-bodega.vue?vue&type=script&lang=js&"
export * from "./plan-bodega.vue?vue&type=script&lang=js&"
import style0 from "./plan-bodega.vue?vue&type=style&index=0&id=80547cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80547cfe",
  null
  
)

export default component.exports